export enum CloudVersion {
    Entry,
    Professional,
    Business,
    Enterprise
}
